<script lang="ts">
import { defineComponent } from "vue";
import formatUtils from "@/businesslogic/utils/formatUtils";
import IconSprite from "@/components/IconSprite.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "EmailBestaetigung",
  emits: ["closeModal"],
  components: { IconSprite },
  setup(props, { emit }) {
    const piniaStore = useFormStore();
    const { formatCurrency } = formatUtils();

    function closeModal() {
      emit("closeModal");
    }

    return {
      piniaStore,
      formatCurrency,
      closeModal,
    };
  },
});
</script>

<template>
  <div class="o-grid o-grid--align-middle">
    <div class="o-grid__cell o-grid__cell--1">
      <icon-sprite icon-name="icon-check-mark" :ist-gross="true" css-style="color: green" />
    </div>
    <div class="o-grid__cell o-grid__cell--11">Vielen Dank! Die E-Mail wurde erfolgreich versandt.</div>
    <div class="o-grid__cell o-grid__cell--12 form-actions u-mar-b-0 u-text-align-right">
      <button class="c-button" type="button" @click="closeModal()">OK</button>
    </div>
  </div>
</template>

<style scoped></style>
